import { render, staticRenderFns } from "./CreateProductFeaturedImage.vue?vue&type=template&id=0283b044"
import script from "./CreateProductFeaturedImage.vue?vue&type=script&lang=js"
export * from "./CreateProductFeaturedImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports